module.exports = __webpack_public_path__ + "media/images/diy/custom_select_arrow_down-52effabcc6531544ac033ac04db37be3.svg";